"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMF = isMF;
const chemical_elements_1 = require("chemical-elements");
const chemical_groups_1 = require("chemical-groups");
function isMF(mf) {
    let tmpMF = mf.replaceAll(/[^A-Za-z]/g, '');
    let parts = tmpMF.replaceAll(/([A-Za-z])(?=[A-Z])/g, '$1 ').split(' ');
    for (let i = 0; i < parts.length; i++) {
        if (!chemical_elements_1.elementsObject[parts[i]] && !chemical_groups_1.groupsObject[parts[i]]) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=isMF.js.map